import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Error from './Error';
import Sync from '../../icons/Sync';
import ErrorRequired from './ErrorRequired';

import { breakpoints } from '../../../utils/breakpoints';
import { formInputFocus } from '../../../utils/shared/focusStyles';

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 1.375rem;

  @media ${breakpoints.tablet} {
    width: 60%;
    margin: 3.125rem auto 0 auto;
  }

  @media ${breakpoints.desktop} {
    width: 50%;
  }
`;

const InputLabel = styled.label`
  color: var(--Theme-Dark, #373737);
  font-family: Nunito;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: 0.21px;
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
  svg {
    margin-bottom: 2px;
    margin-left: 7px;
  }
`;

const Input = styled.input`
  padding: 0.875rem;
  border: 1px solid #bbbbbb;
  border-radius: 2px;
  font-family: 'Open Sans', sans-serif;
  font-size: 1rem;

  &::placeholder {
    color: var(--gray-medium3, #666);
    font-family: "Open Sans";
    font-size: 16px;
    font-style: italic;
    font-weight: 400;
    line-height: 150%; /* 24px */
  }

  &:disabled {
    background-color: #eeeeee;
    cursor: not-allowed;

    &::placeholder {
      color: #555555;
    }
  }

  ${formInputFocus};

  ${props => {
    if (props.hasError) {
      return `
        border-color: #8b1313;
      `;
    }
  }};
`;

export default function TextInput({ value, 
    id, 
    label, 
    placeholder, 
    handleOnChange, 
    disabled, 
    required, 
    error, 
    customInputStyle,
    customInputContainerStyle,
  }) {
  return (
    <InputContainer style={customInputContainerStyle}>
      <InputLabel htmlFor={id}>
        {label}
        {required && <ErrorRequired />}
        {disabled && <Sync />}
      </InputLabel>
      <Input
        id={id}
        value={value}
        name={id}
        autoComplete='off'
        placeholder={placeholder}
        onChange={handleOnChange}
        hasError={!!error}
        disabled={disabled}
        required={required}
        style={customInputStyle}
        // aria-invalid={'true'}
      />
      {error && <Error message={error} />}
    </InputContainer>
  );
}

TextInput.propTypes = {
  error: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  handleOnChange: PropTypes.func.isRequired,
};

TextInput.defaultProps = {
  error: '',
  disabled: false,
  required: false,
  placeholder: '',
};
